
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skolenia-na-mieru",
      function () {
        return require("private-next-pages/skolenia-na-mieru.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skolenia-na-mieru"])
      });
    }
  